import requestAction from '../../utils/requestAction'
import Product from '../../models/Product';

export const upsertProduct = (product: (Product)) =>
  requestAction('PRODUCT_UPSERT')(
    `products${(product as Product).id ? `/${(product as Product).id}` : ''}`,
    (product as Product).id ? 'PUT' : 'POST',
    product
  )
